/* eslint-disable react/no-unused-state */
import React, { PropTypes, Component } from 'react'
import merge from 'lodash/merge'
import Filters from 'components/List/components/Filters'
import { getFiscalYearTimestamps } from 'utils/fiscalYear'
import constants from 'constants'

const styles = Object.assign(
  {},
  require('./PartnerPlanFilter.scss'),
)

class PartnerPlanFilter extends Component {
  static propTypes = {
    filteredPartnerPlans: PropTypes.instanceOf(Array),
    onChangeFilteredPartnerPlans: PropTypes.func,
    onClearFilteredPartnerPlans: PropTypes.func,
    onGetFilterValueFromSession: PropTypes.func,
    onPlanStatusSearchTrigger: PropTypes.func,
    onPlanYearSearchTrigger: PropTypes.func,
    partnerPlans: PropTypes.object,
  }

  static defaultProps = {
    filteredPartnerPlans: [],
    onChangeFilteredPartnerPlans: null,
    onClearFilteredPartnerPlans: null,
    onGetFilterValueFromSession: null,
    onPlanStatusSearchTrigger: null,
    onPlanYearSearchTrigger: null,
    partnerPlans: null,
  }

  constructor(props) {
    super(props)
    // this.handleInitFilteredPersonalInfo = this.handleInitFilteredPersonalInfo.bind(this);
    // this.handleChangeFilteredPersonalInfos = this.handleChangeFilteredPersonalInfos.bind(this);
    this.data = []
    this.state = {
      planStatus: '',
      planYear: '',
      filters: {
        planStatus: null,
        planYear: null,
      },
      filterData: {
        planStatus: constants.LIST_DYNAMICFILTERS('PlanStatus', this.props.partnerPlans.planStatus),
        planYear: constants.LIST_DYNAMICFILTERS('PlanYear', this.props.partnerPlans.planYear),
      },
    }
  }

  componentDidMount() {
    /* const filters = this.state.filters
    const newFilters = merge({}, filters, {
      status: (this.props.personalinfos.selectedStatusFilter === 1 ? 'Active' : 'Inactive'),
    })
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ filters: newFilters }) */

    const { filters } = this.state.filters
    let filterSelection = ''

    if (sessionStorage.getItem(constants.PARTNERPLAN.SEARCHSESSIONKEY.FILTER)) {
      filterSelection = JSON.parse(sessionStorage.getItem(constants.PARTNERPLAN.SEARCHSESSIONKEY.FILTER))
      if (filterSelection.planYear) {
        // eslint-disable-next-line react/no-did-mount-set-state
        // this.setState({ selPlanYear: filterSelection.year })
        setTimeout(() => { this.setState({ planYear: filterSelection.planYear }) }, 800)
      }
      if (filterSelection.planStatus) {
        // eslint-disable-next-line react/no-did-mount-set-state
        // this.setState({ selPlanStage: filterSelection.stage })
        setTimeout(() => { this.setState({ planStatus: filterSelection.planStatus }) }, 800)
      }
      this.filterPartnerPlans(filterSelection.planStatus, filterSelection.planYear)
    }
    const currentFY = this.props.onGetFilterValueFromSession(constants.PARTNERPLAN.SEARCHFILTERSTATE.INITIAL) ? getFiscalYearTimestamps().current.year : ''
    const newFilters = merge({}, filters, {
      planYear: (filterSelection ? filterSelection.planYear : currentFY),
      planStatus: (filterSelection ? filterSelection.planStatus : ''),
    })

    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ filters: newFilters })
  }

  componentWillReceiveProps(nextProps) {
    const { filteredPartnerPlans } = this.props
    this.data = filteredPartnerPlans
    if (nextProps.filteredPartnerPlans !== this.props.filteredPartnerPlans) {
      this.data = nextProps.filteredPartnerPlans
    }
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }
    // not in used the component needs this function to not to throw warnings
  }

  _handleChange = (name, value) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }

    this.setState({ search: stateValue.data.value })
  }

  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }
    // not in used the component needs this function to not to throw warnings
  }

  filterByPlanStatus = (data, filtervalue) => {
    this.props.onPlanStatusSearchTrigger(true)
    this.updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTER.STATUS, filtervalue)
    // eslint-disable-next-line eqeqeq
    return data.filter(item => item.planStatus == filtervalue)
  }

  filterByPlanYear = (data, filtervalue) => {
    this.props.onPlanYearSearchTrigger(true)
    this.updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTER.YEAR, filtervalue)
    // eslint-disable-next-line eqeqeq
    return data.filter(item => item.year == filtervalue)
  }

  filterPartnerPlans = (planStatus, planYear) => {
    let filteredinfo = [...new Set(this.props.partnerPlans.partnerPlans)]
    if (planStatus) {
      filteredinfo = this.filterByPlanStatus(filteredinfo, planStatus)
    }
    if (planYear) {
      filteredinfo = this.filterByPlanYear(filteredinfo, planYear)
    }
    this.props.onChangeFilteredPartnerPlans(filteredinfo)
  }

  clearFilters = () => {
    this.setState({
      planStatus: '',
      planYear: '',
      filters: {
        planStatus: null,
        planYear: null,
      },
    })
    this.props.onClearFilteredPartnerPlans()
    sessionStorage.removeItem(constants.PARTNERPLAN.SEARCHSESSIONKEY.FILTER)
  }

  filter = ({ type = null, value = null }) => {
    // get current filters object from state
    const currentFilters = this.state.filters || {}

    // merge current filters with new filter value
    const newFilters = Object.assign({}, currentFilters, {
      [type]: value,
    })

    // Prepare the individual states based on type
    const newState = {
      filters: newFilters,
    }

    if (type === 'planStatus') {
      newState.planStatus = value
    } else if (type === 'planYear') {
      newState.planYear = value
    }

    this.setState(newState, () => {
      // After state updates, call filterPartnerPlans with latest values
      this.filterPartnerPlans(
        (this.state.planStatus != null && this.state.planStatus !== '')
          ? this.state.planStatus
          : this.state.filters.planStatus,

        (this.state.planYear != null && this.state.planYear !== '')
          ? this.state.planYear
          : this.state.filters.planYear,
      )
    })
  };

  updateFilterSessionObject = (filterBy, filterValue) => {
    let filterSelection = {
      planYear: '',
      planStatus: '',
    }
    if (sessionStorage.getItem(constants.PARTNERPLAN.SEARCHSESSIONKEY.FILTER)) {
      filterSelection = JSON.parse(sessionStorage.getItem(constants.PARTNERPLAN.SEARCHSESSIONKEY.FILTER))
    }
    if (filterBy.toLowerCase() === constants.PARTNERPLAN.SEARCHFILTER.YEAR.toLowerCase()) {
      filterSelection.planYear = filterValue
    }
    if (filterBy.toLowerCase() === constants.PARTNERPLAN.SEARCHFILTER.STATUS.toLowerCase()) {
      filterSelection.planStatus = filterValue
    }
    sessionStorage.setItem(constants.PARTNERPLAN.SEARCHSESSIONKEY.FILTER, JSON.stringify(filterSelection))
  }

  render() {
    return (
      <section className={styles.section}>
        {/* <div className={styles.gridcontainerelement}> */}
        <div className={styles.gridfilterelement}>
          <div className={styles.gridchildfilterelement1}>
            <div />
          </div>
          <div className={styles.gridchildfilterelement2}>
            <Filters
              clearFilters={this.clearFilters}
              filter={this.filter}
              filterData={this.state.filterData}
              rules={this.state.filters}
            />
          </div>

        </div>

      </section>

    )
  }
}

export default PartnerPlanFilter



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/components/PartnerPlan/PartnerPlanFilter.js